const getters = {
  tabBar: state => state.app.tabBar,
  permissions: state => state.user.permissions,
  roles: state => state.user.roles,
  userinfo: state => state.user.user,
  count: state => state.user.count,
  oneminute: state => state.user.oneminute
}

export default getters
